/* @flow */
import { combineEpics } from 'redux-observable';

import {
  SAVE_ENCLAVE_ICON,
  SAVE_ENCLAVE_ICON_SUCCESS,
  SAVE_ENCLAVE_ICON_FAILURE,

  SAVE_TEMPLATE_ICON,
  SAVE_TEMPLATE_ICON_SUCCESS,
  SAVE_TEMPLATE_ICON_FAILURE,
} from './action-types.js';


const saveEpic = (action$, store, { ajax }) =>

  // could be for an enclave or a template
  action$.ofType(SAVE_ENCLAVE_ICON, SAVE_TEMPLATE_ICON)
    .mergeMap(({ type, payload }) => {

      const isSVG = payload.file && payload.file.type.includes("svg");
      let path;
      let successEventType;
      let failureEventType;

      // set variables based on the type of object the icon is being associated with
      switch(type) {
      case SAVE_ENCLAVE_ICON:
        path = 'enclaves';
        successEventType = SAVE_ENCLAVE_ICON_SUCCESS;
        failureEventType = SAVE_ENCLAVE_ICON_FAILURE;
        break;
      case SAVE_TEMPLATE_ICON:
        path = 'enclave-templates';
        successEventType = SAVE_TEMPLATE_ICON_SUCCESS;
        failureEventType = SAVE_TEMPLATE_ICON_FAILURE;
        break;
      default:
        throw `Unrecognized icon action type: ${type}`;
      }

      const url = `/services/${path}/${payload.guid}/${isSVG ? 'icons-svg' : 'icons'}`;

      // construct the form data that will hold the file
      const data = new FormData();
      if (isSVG) {
        data.append('svgIcon', payload.file)
        // TODO Color Support
      }
      else {
        data.append('icon', payload.file);

      }

      // ensure the file is not null
      if (payload.file == null) {
        throw 'Cannot upload, file is null.';
      }

      // post the file to the server
      const resp = ajax({
        method: 'POST',
        url,
        body: data,
        headers: { Accept: '*/*' },
        responseType: 'text',
      });

      // dispatch a success event with the iconUrl and the
      // guid of the resource it was associated with
      return resp.map(({ response }) => ({
        type: successEventType,
        payload: {
          iconUrl: response,
          guid: payload.guid,
        },
      }))
      .catch(err => ({
        type: failureEventType,
      }));
    });

export default combineEpics(
  saveEpic,
);




// WEBPACK FOOTER //
// ./src/app/modules/icons/epics.js